import React from 'react'
import './Bg.css'

const Bg = () => {
  return (
    <div className="my-container">
</div>
  )
}

export default Bg
